var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"tippyTrigger"},[_vm._t("button",[_c('v-btn',{staticClass:"primary",class:_vm.anchorButtonClass,attrs:{"disabled":_vm.disabled,"aria-label":_vm.anchorAriaLabel,"title":_vm.anchorAriaLabel},on:{"click":function($event){_vm.isPopoverOpen = !_vm.isPopoverOpen}}},[_vm._t("anchor",[_vm._v(_vm._s(_vm.anchorAriaLabel)+" ")])],2)],{"events":{
        click: function () {
          _vm.isPopoverOpen = !_vm.isPopoverOpen;
        },

        keydown: function (e) {
          if (e.key === 'Enter') {
            _vm.isPopoverOpen = !_vm.isPopoverOpen;
          }
        }
      },"attr":{
        disabled: _vm.disabled,
        'aria-label': _vm.anchorAriaLabel,
        title: _vm.anchorAriaLabel
      }})],2),_c('div',{ref:"content",staticClass:"popover-content",class:{ 'overflow-override': _vm.overflowOverride }},[_vm._t("content",[_c('h1',[_vm._v("Content")])])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }